export const spaPathReducer = (state = '') => {
    return state;
};
